import React from 'react';
import propTypes from 'prop-types';
import classnames from 'classnames';
import _ from 'lodash';

const {
	bool, arrayOf, shape, string, func
} = propTypes;

function SelectField ({ emptyDefaultValue = true, options = [], ...props }) {
	const selectClassNames = classnames({
		'form-control': true,
		'lss-form-input': true,
		'no-selection': !props.value
	});

	const wrapperClassNames = classnames({
		'form-group': true,
		'form-error': props.formError
	});

	const iosSafariHack = <optgroup disabled hidden />;

	return (
		<div className={wrapperClassNames}>
			{props.label && <span className='lss-form-label'>{props.label}<br /></span>}
			<div className='lss-select-input-wrapper'>
				<select
					className={selectClassNames}
					name={props.name}
					onBlur={props.onBlur ? props.onBlur : _.noop}
					onChange={props.onChange}
					value={props.value}
					aria-label={props.label || props.name}
				>
					{props.ios ? iosSafariHack : null}
					{emptyDefaultValue && <option value=''>{props.placeholder}</option>}
					{options.map(({ value, display }) => <option key={value} value={value}>{display}</option>)}
				</select>
			</div>
			{props.formError && <span className='error-message'>{props.formError}</span>}
		</div>
	);
}

SelectField.propTypes = {
	label: string,
	placeholder: string,
	ios: bool,
	emptyDefaultValue: bool.isRequired,
	name: string.isRequired,
	value: string,
	options: arrayOf(shape({
		value: string.isRequired,
		display: string.isRequired
	})),
	formError: string,
	onChange: func.isRequired,
	onBlur: func
};

export default SelectField;
